const flexgap = [
  "flexgap",
  () => {
    const flex = document.createElement("div");
    flex.style.display = "flex";
    flex.style.flexDirection = "column";
    flex.style.rowGap = "1px";
    flex.appendChild(document.createElement("div"));
    flex.appendChild(document.createElement("div"));
    document.documentElement.appendChild(flex);
    const isSupported = flex.scrollHeight === 1;
    flex.parentNode.removeChild(flex);
    return isSupported;
  }
];
export {
  flexgap as default
};
//# sourceMappingURL=flexgap.es.js.map
